<template>
  <div
    v-if="show"
    class="modal right fade"
    id="myModal2"
    tabindex="-1"
    aria-labelledby="myModalLabel2"
    style="display: block"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" @click.prevent="handleDialogClose">
            <span aria-hidden="true"><i class="fa fa-times" aria-hidden="true"></i></span>
          </button>
          <span id="myModalLabel2" style="background-color: #0054a6; color: white">{{ Title }}</span>
        </div>

        <div class="modal-body">
          <div class="content">
            <AlertComponent
              v-if="isCancelButtonClicked"
              @setWindow="($emit('visibleDialog', false), (show = false), backdropClose())"
              :isCancelButtonClicked="isCancelButtonClicked"
              @hidePopup="isCancelButtonClicked = false"
            ></AlertComponent>
            <div class="body">
              <div class="customSettingName">
                <label for="basic-url" style="font-size: 16px">{{ $t("addCustomSetting.name") }}</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    @change="checkCustomSettingName"
                    class="form-control"
                    :class="{ errorStyle: customSettingNameError }"
                    id="basic-url"
                    v-model="newCustomSetting.name"
                    :maxlength="20"
                    :placeholder="placeholder"
                    style="border-radius: 10px"
                    aria-describedby="basic-addon3"
                  />
                </div>
                <span class="counter" :class="{ errorCounter: customSettingNameCountError }"
                  >{{ newCustomSetting?.name?.length }}/20</span
                >
              </div>
              <span v-if="customSettingNameCountError" :class="{ errorCounter: customSettingNameCountError }">{{
                $t("addCustomSetting.settingNameCanHaveMaximum20Character")
              }}</span>
              <div class="tktTex">
                <label for="basic-url" style="font-size: 16px">{{ $t("addCustomSetting.tktTex") }}</label>
                <div class="input-group mb-3">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      v-model="newCustomSetting.tktTex"
                      id="inlineRadio1"
                      value="Tkt"
                      checked
                    />
                    <label class="form-check-label" for="inlineRadio1">{{ $t("addCustomSetting.tkt") }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      v-model="newCustomSetting.tktTex"
                      id="inlineRadio2"
                      value="Tex"
                    />
                    <label class="form-check-label" for="inlineRadio2">{{ $t("addCustomSetting.tex") }}</label>
                  </div>
                </div>
              </div>
              <div class="allowance">
                <label class="form-check-label" for="customRange3" style="font-size: 16px">{{
                  $t("addCustomSetting.allowance")
                }}</label>
                <output style="position: absolute; right: 20px">{{ newCustomSetting.defaultAllowance }}%</output>
                <input
                  type="range"
                  class="custom-range"
                  min="0"
                  max="50"
                  step="1"
                  v-model="newCustomSetting.defaultAllowance"
                  id="customRange3"
                />
              </div>
              <div class="defaultSetting mt-3">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="inlineRadioOptions"
                    id="inlineCheckBox3"
                    v-model="isDefaultCustomSetting"
                    style="border: 1px solid black"
                  />
                  <label class="form-check-label" for="inlineCheckBox3">{{
                    $t("addCustomSetting.setAsMyDefaultSetting")
                  }}</label>
                </div>
              </div>
              <hr style="width: 100%; text-align: left; margin-left: 0" />
              <div class="buttons">
                <button class="btn btn-sm btn-primary mt-2" style="width: 7rem; border-radius: 4px" @click="onSave">
                  {{ $t("operationCreateComp.save") }}
                </button>
                <button
                  class="btn btn-sm btn-secondary mt-2"
                  style="width: 8rem; border-radius: 4px; margin-left: 10px"
                  @click="handleDialogClose"
                >
                  {{ $t("operationCreateComp.cancel") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import { CustomSettingsApi } from "@/api";
import AlertComponent from "./AlertComponent.vue";
import { UserCustomSettingDto } from "@/api/model";
import $ from "jquery";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { BModal, BOffcanvas } from "bootstrap-vue-next";

export default defineComponent({
  name: "AddCustomSetting",
  emits: ["visibleDialog", "getCustomSettingId", "getCustomSettingsData", "save"],
  components: {
    ComboBox,
    AlertComponent,
    BModal,
    BOffcanvas
  },
  setup() {
    const customSettingsApi = new CustomSettingsApi()!;
    return {
      customSettingsApi
    };
  },
  props: {
    showCreatePopup: null as any,
    duplicateCustomSettingId: null as any
  },
  data() {
    return {
      show: this.showCreatePopup,
      isDefaultCustomSetting: false,
      customSettingNameError: false,
      customSettingNameCountError: false,
      customSettingNameEmptyError: false,
      Title: "" as any,
      isCancelButtonClicked: false,
      placeholder: this.$t("addCustomSetting.settingNameShouldBeUnique") as any,
      newCustomSetting: {
        id: 0,
        name: "",
        defaultAllowance: 10,
        tktTex: "Tkt"
      } as UserCustomSettingDto,
      toast: null as any
    };
  },
  mounted() {
    if (this.show) {
      this.$nextTick(() => {
        ($("#myModal2") as any).modal("show");
      });
    }
  },
  created(): void {
    this.toast = useToast();
    this.getCustomSetting();
    if (this.duplicateCustomSettingId > 0) {
      this.Title = this.$t("addCustomSetting.duplicateCustomSetting");
    } else {
      this.Title = this.$t("addCustomSetting.addCustomSetting");
    }
  },
  methods: {
    handleDialogClose() {
      this.isCancelButtonClicked = true;
    },
    backdropClose() {
      if (!this.show) {
        setTimeout(() => {
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) backdrop.remove();

          document.body.classList.remove("modal-open");
          document.body.style.removeProperty("padding-right");
          document.body.style.removeProperty("overflow");
        }, 300);
      }
    },
    async checkCustomSettingName(): Promise<void> {
      this.newCustomSetting.name = this.newCustomSetting.name?.trim();
      await this.customSettingsApi.apiIsCustomSettingExistByNameGet(this.newCustomSetting.name as string).then(res => {
        if (res.data) this.customSettingNameError = false;
        else this.customSettingNameError = true;
      });
      if (this.newCustomSetting.name!.length > 20) this.customSettingNameCountError = true;
      else this.customSettingNameCountError = false;
      if (this.newCustomSetting.name?.length == 0) this.customSettingNameEmptyError = true;
      else this.customSettingNameEmptyError = false;
    },
    async getCustomSetting(): Promise<void> {
      await this.customSettingsApi.apiGetCustomSettingByIdGet(this.duplicateCustomSettingId).then(res => {
        this.newCustomSetting.name = res.data.name;
        this.newCustomSetting.defaultAllowance = res.data.defaultAllowance;
        this.newCustomSetting.tktTex = res.data.tktTex;
        if (this.duplicateCustomSettingId > 0) {
          this.newCustomSetting.name = this.newCustomSetting.name + " - Copy";
          this.newCustomSetting.id = this.duplicateCustomSettingId;
        } else {
          this.newCustomSetting.name = "";
        }
      });
      this.checkCustomSettingName();
    },
    async onSave(): Promise<void> {
      await this.checkCustomSettingName();
      if (!this.customSettingNameError && !this.customSettingNameCountError && !this.customSettingNameEmptyError) {
        await this.customSettingsApi
          .apiCreateCustomSettingPost(this.isDefaultCustomSetting, this.newCustomSetting)
          .then(res => {
            this.$emit("getCustomSettingId", res.data);
            this.$emit("getCustomSettingsData");
          });
        this.show = false;
        this.$emit("save");
        document.body.classList.remove("modal-open");
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();
      } else if (this.customSettingNameEmptyError) {
        this.toast.error(this.$t("addCustomSetting.enterSettingName") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.toast.error(this.$t("addCustomSetting.eitherDuplicateOrExtendedSettingName") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    }
  }
});
</script>
<style scoped>
.body {
  display: grid;
  margin-top: 15px;
}
.counter {
  float: right;
  position: relative;
  top: -31px;
  right: 8px;
  z-index: 99999;
}
.name {
  background-color: #dbe3ea;
  width: 20rem;
  height: 35px;
  border-radius: 10px;
  text-indent: 20px;
}
.lastChanged {
  font-size: 12px;
  color: #a09d9d;
  padding: 6px;
}
.errorStyle {
  border-color: red;
}
.errorCounter {
  color: red;
  position: relative;
  top: -30px;
}
.stitch {
  width: 5rem;
  height: 2rem;
  border: 1px solid #ced4da;
  border-radius: 5px;
}
.vue-js-switch .v-switch-input {
  position: relative !important;
  opacity: 0 !important;
  width: 40px !important;
  height: 40px !important;
  top: 12px !important;
  left: 7px !important;
  z-index: 1000 !important;
}
.vue-js-switch .v-switch-core {
  display: block !important;
  position: relative !important;
  box-sizing: border-box !important;
  outline: 0 !important;
  margin: 0 !important;
  transition:
    border-color 0.3s,
    background-color 0.3s !important;
  top: -19px !important;
  left: 5px !important;
  user-select: none !important;
}
.vue-js-switch .v-switch-label {
  position: absolute !important;
  top: 9.5px !important;
  left: 30px !important;
  font-weight: 600 !important;
  color: #0054a6 !important;
  z-index: 1 !important;
}
.k-dialog-wrapper {
  align-items: flex-end !important;
}
.k-window-titlebar {
  color: #000000 !important;
  background-color: #ffffff !important;
}
.b-toaster {
  z-index: 999999 !important;
}
.k-input {
  font-size: 12px !important;
  padding: 0px 0px !important;
}
.k-slider-horizontal {
  width: 39rem !important;
}
.form-input {
  height: 40px;
  border-radius: 10px;
  width: 208%;
  text-align: center;
}
.form-input:focus {
  box-shadow: 0 0 0 2px #b3c1d0 !important;
}
.modal-right {
  width: 100%;
}
.btn-primary {
  background-color: #0054a6;
  color: white;
}
.modal-backdrop {
  z-index: 10400;
}
.modal-header {
  background-color: #0054a6;
  color: white;
  padding: 0.75rem;
  height: auto;
  border-top-left-radius: 0 !important;
}

.modal.right .modal-dialog {
  position: fixed;
  margin: 0;
  right: -1;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 860px;
  max-width: 100vw;
  font-family: Arial, Helvetica, sans-serif;
  color: white;
}
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0 !important;
}

body.modal-open {
  overflow-x: hidden;
  border-radius: 0 !important;
}
.modal-header i.fa-times {
  color: white !important;
}
.modal {
  pointer-events: none !important;
}
input[type="radio"].form-check-input:checked {
  background-color: #ffffff;
  border-color: #858585;
  background-image: radial-gradient(circle at center, #858585 50%, transparent 40%);
}
.form-check-input {
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.75) !important;
}
input[type="checkbox"].form-check-input:checked {
  background-color: #858585 !important;
}
</style>
